var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"dashboardMap",staticClass:"map",attrs:{"id":"dashboardMap"}},[_c('UploadFeatures')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }